var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('PageTitle',{attrs:{"icon":"fal fa-fw fa-bullhorn"}},[_vm._v("\n    Send Campaign\n  ")]),_vm._v(" "),_c('email-campaign-stepper'),_vm._v(" "),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }